import ButtonAndDropdown from "./ButtonAndDropdown";
import useButtonAndDropdownState from "./ButtonAndDropdown/hooks";

export const HOOKS = {
  "button-and-dropdown": useButtonAndDropdownState,
  "only-buttons": useButtonAndDropdownState,
  "only-dropdown": useButtonAndDropdownState,
}

export const TEMPLATES = {
  "button-and-dropdown": ButtonAndDropdown,
  "only-buttons": ButtonAndDropdown,
  "only-dropdown": ButtonAndDropdown,

}
